import { useInsightsSectionContent } from './useInsightsSectionContent';
import { parseInsightsNewsContent } from '../utils/insightsContent';

export const useInsightsNewsContent = () =>
  useInsightsSectionContent(parseInsightsNewsContent);
